<app-option-bar [type]="'MASTERSUITE'" [details]="mastersuiteDetails"></app-option-bar>
<div class="container-fluid endpoint-wrapper">
  <div class="content-wrapper">
    <div class="inner-nav">
      <app-left-menu [details]="mastersuiteDetails" [type]="'MASTERSUITE'"></app-left-menu>
    </div>
    <div class="inner-content collapsed">
      <div class="common-section">
        <div class="common-heading">History</div>
        <div class="history-log-sec" *ngFor='let item of historyLog'>
          <ngb-accordion #acc="ngbAccordion">
            <ngb-panel id="toggle-1"
              title="{{item.changedBy.displayName}} made a change on {{item.json.changedLogs?.entity || item.json?.entity}} at {{item.changedOn | localDate}}">
              <ng-template ngbPanelContent>
                <div>
                  <ng-template id="changedLogHistories" #changedLogHistories let-data='data'>
                    <strong class="text-capitalize">{{data.entity}}</strong>
                    <div *ngIf="data?.changedLogs">
                      <div class="col-12 row" *ngFor="let data of data?.changedLogs">
                        <div class="col-4 text-capitalize">{{data.fieldName}}</div>
                        <div class="col-4 text-truncate">{{(data.fieldName === 'password') ? '******' : data.oldVal |
                          json }}</div>
                        <div class="col-4  text-truncate">{{(data.fieldName === 'password') ? '******' : data.newVal |
                          json}}</div>
                      </div>
                    </div>
                    <div *ngIf="data.changedLogHistories">
                      <div>{{data.entity}}</div>
                      <div *ngFor="let data of data.changedLogHistories">
                        <ng-container [ngTemplateOutlet]="changedLogHistories"
                          [ngTemplateOutletContext]="{data:data}"></ng-container>
                      </div>
                    </div>
                  </ng-template>
                  <div class='row'>
                    <div class='col-4 font-weight-bold'>
                      Field
                    </div>
                    <div class="col-4 font-weight-bold">
                      Orignal value
                    </div>
                    <div class='col-4 font-weight-bold'>
                      New value
                    </div>
                  </div>
                  <br />
                  <div class='row' *ngFor="let data of item.json?.changedLogs">
                    <div class='col-4'>
                      {{data.fieldName}}
                    </div>
                    <div class='col-4'>
                      {{data.oldVal | json}}
                    </div>
                    <div class='col-4'>
                      {{data.newVal | json}}
                    </div>
                  </div>
                  <div class='row' *ngFor="let data of item.json?.changedLogHistories">
                    <div class='col-12'>
                      <ng-container [ngTemplateOutlet]="changedLogHistories"
                        [ngTemplateOutletContext]="{data:data}"></ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
    </div>
  </div>
</div>